import { request } from "./http";

export interface TcaRow {
  bucket: string;
  fill_count: number;
  notional_total: number;
  avg_slippage_bps: number;
  median_slippage_bps: number;
  p99_slippage_bps: number;
  avg_latency_ms: number;
  p99_latency_ms: number;
}

export const tca = {
  byVenue: (days = 7) => request<TcaRow[]>(`/api/v1/admin/tca/by-venue?days=${days}`),
  bySymbol: (days = 7, topN = 20) =>
    request<TcaRow[]>(`/api/v1/admin/tca/by-symbol?days=${days}&top_n=${topN}`),
  byHour: (days = 7) => request<TcaRow[]>(`/api/v1/admin/tca/by-hour?days=${days}`),
};
